import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class ConnectService {

  constructor(private http:HttpClient) { }
    getone(num){
      return this.http.get(`https://api-thirukkural.vercel.app/api?num=${num}`);
  }
}
